import loop54 from '~/lib/api/loop54';
import { Loop54Types } from '~/lib/data-contract';
import { getUrl } from '~/services/loop54/utils';

export default function createEvents(event: Loop54Types.Event) {
    return loop54
        .post(getUrl('/createEvents'), {
            json: {
                events: [event],
            },
        })
        .json<Loop54Types.Response>();
}
